import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import Banner from "../components/banner"
import InfoSection from "../components/info-section"
import Services from "../components/services"
import ContactBox from "../components/contact-box"

import "../styles/main.scss"

const Home = () => {
  const page = "index"

  return (
    <Layout page={page}>
      <Banner />

      <InfoSection />

      <div className='parallax center'>
        <div className='parallaxShade'></div>
        <h1 className='parallaxTitle'>
          Profesyonel <br />
          <strong>Su Tesisatı Hizmetleri</strong>
        </h1>
        <h2 className='parallaxText'>
          <strong>Su Tesisatı</strong> Sorunlarınıza <br /> Kalıcı ve Kaliteli
          Hizmet Sunuyoruz!
        </h2>
        <Link
          className='button mt-30 mx-auto'
          to='https://wa.me/905550175093?text=Merhaba'
          target='_blank'
          rel='noopener noreferrer'
        >
          SERVİS TALEP
        </Link>
      </div>

      <Services />

      <ContactBox />
    </Layout>
  )
}

export default Home
